'use client';

import { Spinner } from 'flowbite-react';

export default function DefaultSpinner() {
  return (
    <Spinner aria-label="Default status example" />
  )
}